module.exports = __webpack_public_path__ + "img/01-mobile.73c1da05.png";